import { defineComponent as _defineComponent } from 'vue'
import { Release } from "@/CodegenTypes";
import { customMoment } from "@/main";
import { first, last } from "lodash";
import { queries } from "@/apollo";

import { useRootStore } from "@/store/pinia";
import { computed, watch } from "vue";
import { useQuery } from "@vue/apollo-composable";
import { useRoute, useRouter } from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'DateSelector',
  props: {
    weeksBackCount: { default: 0 },
    filterType: { default: "report" },
    ranged: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { weeksBackCount: number, filterType: "report" | "not-over" | "not-over-or-today", ranged: boolean };



const { result } = useQuery<{ releases: Release[] }>(queries.releases, {
  appMode: computed(() => useRootStore().appMode),
  weeksBackCount: props.weeksBackCount,
}, {
  fetchPolicy: 'network-only'
});

const route = useRoute()
const router = useRouter()

const selectedStartReleaseDate = computed({
  get() {
    const query = route.query.startReleaseDate;
    return Array.isArray(query) ? first(query) : query;
  },
  set(newVal: string | null | undefined) {
    if (!route.name || !newVal) {
      setDefaultRelease();
      return;
    }
    let endReleaseDate = undefined;
    if (props.ranged) {
      const newValIsAfterEnd = customMoment(newVal).isAfter(
        customMoment(selectedEndReleaseDate.value)
      );
      if (newValIsAfterEnd) {
        endReleaseDate = newVal;
      } else {
        endReleaseDate = selectedEndReleaseDate.value;
      }
    }

    router
      .replace({
        name: route.name,
        query: {
          ...route.query,
          startReleaseDate: newVal,
          endReleaseDate,
        },
      })
      .catch((err) => err);
  }
})

const selectedEndReleaseDate = computed({
  get() {
    const query = route.query.endReleaseDate;
    return Array.isArray(query) ? first(query) : query;
  },
  set(newVal: string | null | undefined) {
    if (!props.ranged) {
      return;
    }
    if (!route.name || !newVal) {
      setDefaultRelease();
      return;
    }
    router
      .replace({
        name: route.name,
        query: {
          ...route.query,
          endReleaseDate: newVal,
        },
      })
      .catch((err) => err);
  }
})

const drawDateStartSelectOptions = computed(() => {

  if (!result.value?.releases) {
    return [];
  }
  return [...result.value?.releases || []]
    .sort(
      (a, b) =>
        customMoment(b.releaseDate).unix() -
        customMoment(a.releaseDate).unix()
    )
    .map((release) => {
      return {
        label: customMoment(release.releaseDate).format("DD MMM YYYY (ddd)"),
        value: release.releaseDate,
      };
    });
})

const drawDateEndSelectOptions = computed(() => {

  if (!result.value?.releases) {
    return [];
  }
  return result.value?.releases
    .filter((release) => release)
    .sort(
      (a, b) =>
        customMoment(b.releaseDate).unix() -
        customMoment(a.releaseDate).unix()
    )
    .map((release) => {
      return {
        label: customMoment(release.releaseDate).format("DD MMM YYYY (ddd)"),
        value: release.releaseDate,
        disabled: customMoment(release.releaseDate).isBefore(
          customMoment(selectedStartReleaseDate.value)
        ),
      };
    });
});

watch(() => result.value?.releases, () => setDefaultRelease());

function setDefaultRelease() {
  if (
    !result.value?.releases ||
    (!props.ranged && selectedStartReleaseDate.value) ||
    (props.ranged &&
      selectedStartReleaseDate.value &&
      selectedEndReleaseDate.value)
  ) {
    return;
  }
  if (props.filterType === "report") {
    const reportedGenerated = result.value?.releases
      .filter((r) => r.reportsGenerated)
      .sort(
        (a, b) =>
          customMoment(a.releaseDate).unix() -
          customMoment(b.releaseDate).unix()
      );
    const release = last(reportedGenerated);
    if (release) {
      selectedStartReleaseDate.value = release?.releaseDate;
      if (props.ranged) {
        selectedEndReleaseDate.value = release?.releaseDate;
      }
    } else {
      const releasesNotOver = result.value?.releases
        .filter((r) => !r.isOver)
        .sort(
          (a, b) =>
            customMoment(a.releaseDate).unix() -
            customMoment(b.releaseDate).unix()
        );
      const release = first(releasesNotOver);
      selectedStartReleaseDate.value = release?.releaseDate;
      if (props.ranged) {
        selectedEndReleaseDate.value = release?.releaseDate;
      }
    }
  } else if (props.filterType === "not-over") {
    const releasesNotOver = result.value?.releases
      .filter((r) => !r.isOver)
      .sort(
        (a, b) =>
          customMoment(a.releaseDate).unix() -
          customMoment(b.releaseDate).unix()
      );
    const release = first(releasesNotOver);
    selectedStartReleaseDate.value = release?.releaseDate;
    if (props.ranged) {
      selectedEndReleaseDate.value = release?.releaseDate;
    }
  } else if (props.filterType === "not-over-or-today") {
    let release;
    const releaseToday = result.value?.releases.find((r) =>
      customMoment(r.releaseDate)
        .startOf("day")
        .isSame(customMoment().startOf("day"))
    );
    if (releaseToday) {
      release = releaseToday;
    } else {
      const releasesNotOver = result.value?.releases
        .filter((r) => !r.isOver)
        .sort(
          (a, b) =>
            customMoment(a.releaseDate).unix() -
            customMoment(b.releaseDate).unix()
        );
      release = first(releasesNotOver);
    }
    selectedStartReleaseDate.value = release?.releaseDate;
    if (props.ranged) {
      selectedEndReleaseDate.value = release?.releaseDate;
    }
  }
}

return { __sfc: true,props, result, route, router, selectedStartReleaseDate, selectedEndReleaseDate, drawDateStartSelectOptions, drawDateEndSelectOptions, setDefaultRelease }
}

})